import React from 'react';
import { Target, Zap, Award } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-orange-100 rounded-full mb-4">
            <span className="text-sm font-semibold text-orange-700">Our Mission</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Transforming Mandarin Excellence
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            At CROMAN, we are dedicated to unlocking the full potential of Croatian mandarins through innovative deep processing technologies. Our mission is to deliver premium mandarin products that preserve natural quality while meeting the highest industry standards.
          </p>
        </div>

        {/* Value Props */}
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity"></div>
            <div className="relative p-8 bg-white rounded-2xl border-2 border-gray-100 hover:border-orange-200 transition-all">
              <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <Target className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Precision Processing</h3>
              <p className="text-gray-600 leading-relaxed">
                Advanced extraction techniques that maximize yield while maintaining the integrity of natural flavors and nutrients.
              </p>
            </div>
          </div>

          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity"></div>
            <div className="relative p-8 bg-white rounded-2xl border-2 border-gray-100 hover:border-blue-200 transition-all">
              <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <Zap className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Innovation Driven</h3>
              <p className="text-gray-600 leading-relaxed">
                Combining traditional Croatian mandarin heritage with cutting-edge processing technology for superior products.
              </p>
            </div>
          </div>

          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity"></div>
            <div className="relative p-8 bg-white rounded-2xl border-2 border-gray-100 hover:border-green-200 transition-all">
              <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center mb-6 shadow-lg">
              <Award className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Quality Commitment</h3>
              <p className="text-gray-600 leading-relaxed">
                Rigorous quality control at every stage ensures our products meet and exceed international standards.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;